import React from 'react';
import Link from '3-components/Link/Link';
import Icon from '3-components/Icon/Icon';
import { dataLayerResultClicked } from '../../../js/utils/dataLayers';

const SearchResult = ({ data, searchState }) => {
    const { hit } = data;
    let iconName;
    if (hit.page_type === 'Blog post') {
        iconName = 'message-square';
    } else if (hit.page_type === 'Location') {
        iconName = 'map-pin';
    } else if (hit.page_type === 'Download') {
        iconName = 'import';
    } else {
        iconName = 'file';
    }

    const stat = parseInt(document.querySelector('.algolia-search-searchbar .custom-stats').textContent, 10);

    return (
        <div className="search-result">
            <div className="result-content">
                <h4 className="hit-title">{hit.title}</h4>
                <p className="hit-description">{hit.description}</p>
                <Link
                    href={hit.url}
                    linkText="Learn More"
                    linkSize="sm"
                    onClick={() => {
                        // eslint-disable-next-line no-underscore-dangle
                        dataLayerResultClicked(searchState.query, stat, hit.title, hit.__position);
                    }}
                />
            </div>
            <div className="result-type"><Icon icon={iconName} />{hit.page_type === 'Blog post' ? 'Blog' : hit.page_type}</div>
        </div>
    );
};

export default SearchResult;
